import React, { createContext, useState } from "react";
const CadastroContext = createContext();

const CadastroProvider = ({ children }) => {
  const [dados, setDados] = useState({tipoDocumento: "cnpj", tipo: "", is_matriz: false});

  return (
        <CadastroContext.Provider value={{ dados, setDados}}>
            {children}
        </CadastroContext.Provider>
  );
}

export { CadastroContext, CadastroProvider };
